<script>
    import kritikes from "../stores/kritikes";
    import geos from "../stores/geos";
    import {findNode, backPath} from "../lib/lib";
    import {kritikesMark} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    export let location;

    let parentsPath = '';

    const onClick = (event = null) => {
        $kritikes.selected_id = location.id;
    }

    const onToggle = (event = null) => {
        if (location.children.length > 0) {
            location.expanded = !location.expanded;
        }
        onClick(event);
    }

    const onToggleLocationMark = async () => {
        location.is_marked = +location.is_marked == 1 ? 0 : 1;

        let [err, res] = await kritikesMark(location.id, location.is_marked);

        if (err) {
            alert('error ' + err)
            return;
        }

        success.show("Η περιοχή ενημερώθηκε.");
    }

    const onNameClick = (event = null) => {
        if (event.ctrlKey && location.children.length > 0) {
            onToggle();
            return;
        }
        if (event.altKey) {
            $geos.search_term = location.name;
        }
    }

    const onFindMatch = location_id => {
        $geos.search_term = location_id;
    }

    const onRemoveMatch = (geo_id) => {
        let path = backPath(geo_id, $geos.tree);
        app_alert.show('confirm', `Να διαγραφεί η συσχέτιση με το geo <strong>${path}</strong>;`, () => removeMatch(geo_id));
    }

    const removeMatch = (geo_id) => {
        let match = $kritikes.matches.find(x => x.geo_id === geo_id && x.match_id === location.id);
        if (match) {
            $kritikes.matches = $kritikes.matches.filter(x => (x !== match));
            location.geo_matches = null;

            // reset matches for geo
            let geo = findNode(geo_id, $geos.tree);
            geo.geo_matches = null;
            $geos.tree = $geos.tree;
            success.show("Η συσχέτιση διαγράφτηκε.");
        }
    }

    const onOpenMap = () => {
        let parent = findNode(location.parent_id, $kritikes.tree);
        window.open(`https://www.google.com/maps/place/${location.name}, ${parent.name}`, '_blank').focus();
    }

    $:{
        if (!location.geo_matches) {
            // find multiple matches for this location
            let matches = $kritikes.matches.filter(x => x.match_id === location.id);
            if (matches.length) {
                location.geo_matches = [];
                matches.map(item => {
                    location.geo_matches = [...location.geo_matches, {
                        geo_id: item.geo_id,
                        geo_path: backPath(item.geo_id, $geos.tree)
                    }];
                });
            }
        }

        if ($kritikes.marked_id === location.id) {
            parentsPath = backPath(location.parent_id, $kritikes.tree);
        } else {
            parentsPath = '';
        }
    }
</script>

<div class="node-group level-{ location.level }" id="kritikes-item-{ location.id }"
     on:click|preventDefault|stopPropagation="{ onClick }">
    <div class="node" class:selected={ location.id === $kritikes.selected_id }>
        {#if location.children.length > 0}
            <div class="toggle" on:click|preventDefault|stopPropagation="{ onToggle }">
                {#if location.expanded}
                    <i class="fa fa-chevron-down"></i>
                {:else}
                    <i class="fa fa-chevron-right"></i>
                {/if}
            </div>
        {/if}

        <div class="name" class:marked="{ $kritikes.marked_id === location.id }"
             class:not-visible="{ +location.visible == 1 }"
             on:click="{ onNameClick }">
            <span title="id: { location.id }">{ location.name }</span>
            {#if parentsPath}
                <div class="marked-path">
                    { parentsPath }
                </div>
            {/if}
            {#if location.geo_matches}
                <div class="matches">
                    {#each location.geo_matches as match, index}
                        {#if index < 5}
                            <div class="match allow-remove">
                                { match.geo_path }
                                <div class="find" on:click={ () => onFindMatch(match.geo_id) }>«</div>
                                <div class="remove" on:click={ () => onRemoveMatch(match.geo_id) }>&times;</div>
                            </div>
                        {:else if index === 5}
                            <div class="match allow-remove">
                                και άλλες { location.geo_matches.length - index }
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}
        </div>
        {#if location.level > 1}
            <div class="button" title="Αναζήτηση σε google maps" on:click="{ onOpenMap }"><i
                    class="fa fa-map-marker"></i></div>
        {/if}
        {#if location.total_ads > 0}
            <div class="button" title="σύνολο αγγελιών">{location.total_ads}</div>
        {/if}
        <!--{#if location.level > 0}-->
        <!--    <div class="button" on:click="{ onToggleLocationMark }"><i class="fa fa-warning"></i></div>-->
        <!--{/if}-->
    </div>

    {#if location.expanded}
        <div class="children">
            {#each location.children as child}
                <svelte:self location="{ child }"/>
            {/each}
        </div>
    {/if}
</div>
